import { Appendix } from "../../../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../../../shared/entities/scripts/study";
import { FormatDate, GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { RenderDateMDY } from "../../../../../../shared/scripts/table-functions";
import { SiteInfo } from "../../../../sites/shared/sites.entities";
import { VisitEvent } from "./visits.entities";
import { VisitLookup } from "./visits.lookup";


export class VisitsDialog {
    static table: any = undefined;

    static Initialize() {
        VisitsDialog.table = $('#visits-details-modal #dialog-details-table').DataTable({
            //retrieve: true,
            autoWidth: true,
            //"order": [[3, "asc"]],
            info: false,
            paging: false,
            scrollX: true,
            scrollY: '70vh',
            searching: false,
            columns: [
                { data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: { _: "VisitOrdering", display: "Visit", sort: "VisitOrdering" }, title: "Visit", className: "text-left font-size12 nowrap" },
                { data: "VisitStatus", title: "Status", className: "text-left font-size12 nowrap" },
                { data: "Subject", title: "Participant", className: "text-left font-size12 nowrap" },
                { data: "DateCompletion", title: "Completion Date", className: "text-left font-size12 nowrap", render: RenderDateMDY },
                { data: "DateTargetCompletion", title: "Target Date", className: "text-left font-size12 nowrap", render: RenderDateMDY },
                { data: { _: "VisitWindowString", sort: "DateWindowLow" }, title: "Visit Window", className: "text-left font-size12 nowrap" },
            ]
        });
    }

    public static ShowDialog(visits: VisitEvent[]): void {
        //console.log("show", visits);
        let tableRows: VisitDialogRow[] = visits.map((v: VisitEvent) => new VisitDialogRow(v));
        //console.log(tableRows);

        if (VisitsDialog.table == undefined) { VisitsDialog.Initialize(); }

        VisitsDialog.table.clear();
        VisitsDialog.table.rows.add(tableRows).draw();

        $('#visits-details-modal').on('shown.bs.modal', () => {
            VisitsDialog.table.columns.adjust();
            $('#visits-details-modal .dataTables_scrollBody').scrollTop(0);
            $('#visits-details-modal #modal-title').text("Number of Visit Events = " + FormatNumberWithCommas(visits.length + ""));
            //$('#visits-details-modal-count').text(visits.length);
        });

        $('#visits-details-modal').modal('show');

    }
}


export class VisitDialogRow {
    Study: string;
    Appendix: string;
    SiteNumber: string;
    Subject: string;
    Visit: string;
    VisitOrdering: number;
    VisitStatus: string;
    DateCompletion: string;
    DateTargetCompletion: string;
    DateWindowLow: number;
    VisitWindowString: string;

    constructor(event: VisitEvent) {
        this.Study = Study.GetStudyName(event.StudyId);
        this.Appendix = Appendix.GetAppendixName(event.AppendixId);
        this.SiteNumber = SiteInfo.FormatSiteNumber(event.SiteNumber);
        this.Subject = event.SubjectId;
        this.Visit = VisitLookup.GetVisit(event.VisitId);
        this.VisitOrdering = VisitLookup.GetVisitOrdering(event.VisitId);
        this.VisitStatus = VisitLookup.GetVisitStatus(event.VisitStatusId);
        this.DateCompletion = event.VisitDateStr;
        this.DateTargetCompletion = event.TargetDateStr;

        let dateLow: Date = GetDateFromString(event.VisitLowerDateStr, "slash-month-day-year");
        let dateHigh: Date = GetDateFromString(event.VisitUpperDateStr, "slash-month-day-year");
        this.VisitWindowString = FormatDate(dateLow, "mo-day-year") + " to " + FormatDate(dateHigh, "mo-day-year");
        this.DateWindowLow = dateLow.getTime();
    }
}